import styled from 'styled-components';
import Alert from '@material-ui/lab/Alert';
import { Link } from 'react-router-dom';

import { warnHighlightColor, warnTextColor } from '../../../lib/theme';

// Burnt-orange fill with white bold text is 5.5:1 (WCAG AA); MUI's stock filled warning is ~2:1.
export const ParentLoginAlert = styled(Alert)`
  && {
    margin-top: 32px;
    background-color: ${warnTextColor};
    color: #fff;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.4;
  }

  && .MuiAlert-icon {
    color: #fff;
    font-size: 32px;
  }

  && .MuiAlertTitle-root {
    font-weight: 800;
    font-size: 1.25rem;
    text-transform: uppercase;
  }
`;

export const ParentLoginLink = styled(Link)`
  display: inline-block;
  margin-top: 12px;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: #fff;
  color: ${warnTextColor};
  font-weight: 800;
  text-transform: uppercase;
  text-decoration: none;

  &:hover {
    background-color: ${warnHighlightColor};
  }

  /* Keyboard focus has to clear the white fill against the orange alert. */
  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
`;
